import { Link } from '@material-ui/core'
import Image from 'next/image'
import React from 'react'
import { SERVICES_URL } from '../../../components/menu-service-button'

import { usePlainHeaderStyles } from './plain-header.styles'

export const PlainHeader = (locale: any) => {
  const classes = usePlainHeaderStyles()

  const url = SERVICES_URL

  return (
    <header className={classes.root}>
      <Link href={locale === 'ru' ? `${url.main}/ru` : `${url.main}`}>
        <Image
          width="136"
          height="40"
          src="/assets/logo-header.svg"
          alt=""
          layout="fixed"
        />
      </Link>
    </header>
  )
}
